export default __webpack_public_path__ + "static/media/project-setup-placeholder.185eab23.svg";